import React, { PureComponent } from 'react'

import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'
import { getMessage, getReferralLink, SHARE_TITLE } from 'SocialLinks/socialReferralHelper'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { actionTypes } from 'actions/actionTypes'
import Overlay from 'components/Overlay'
import { SocialShareSheetContainer } from 'components/SocialLinks/SocialShareSheet'

import css from './SocialShareSheetCTA.css'

const propTypes = {
  referralCode: PropTypes.string.isRequired,
  isFixed: PropTypes.bool.isRequired,
  trackingReferFriend: PropTypes.func.isRequired,
  rafOffer: ImmutablePropTypes.map.isRequired,
}

class SocialShareSheetCTA extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { isShareSheetOpen: false }
  }

  onClick = (referralLink) => {
    const { rafOffer } = this.props

    if (navigator.share) {
      navigator
        .share({
          title: SHARE_TITLE,
          url: referralLink,
          text: getMessage(rafOffer),
        })
        .catch((error) => {
          // Dismissing the native sheet rejects with AbortError; anything else means the share
          // itself failed, so the in-page sheet takes over.
          if (error?.name !== 'AbortError') {
            this.openShareSheet()
          }
        })
      const { trackingReferFriend } = this.props
      trackingReferFriend(actionTypes.REFER_FRIEND_LINK_SHARE, 'NativeReferFriendInterface Opened')
    } else {
      this.openShareSheet()
    }
  }

  openShareSheet = () => {
    const { trackingReferFriend } = this.props
    trackingReferFriend(actionTypes.REFER_FRIEND_SHARE_SHEET_OPENED, 'ReferFriendShareSheet Opened')
    this.setState({ isShareSheetOpen: true })
  }

  closeShareSheet = () => {
    const { trackingReferFriend } = this.props
    trackingReferFriend(actionTypes.REFER_FRIEND_SHARE_SHEET_CLOSED, 'ReferFriendShareSheet Closed')
    this.setState({ isShareSheetOpen: false })
  }

  render() {
    const { isShareSheetOpen } = this.state
    const { referralCode, isFixed } = this.props
    const ctaContainerClasses = classnames(css.mobileShow, {
      [css.fixedMobileCTAContainer]: isFixed,
    })

    const referralLink = getReferralLink(referralCode, '', '&utm_source=weblink')

    return (
      <div className={ctaContainerClasses}>
        <Button
          onClick={() => this.onClick(referralLink)}
          colorVariant={ButtonColorVariant.Secondary}
          width="100%"
        >
          Share your link
        </Button>
        <Overlay open={isShareSheetOpen} from="bottom">
          <SocialShareSheetContainer onClose={this.closeShareSheet} referralCode={referralCode} />
        </Overlay>
      </div>
    )
  }
}

SocialShareSheetCTA.propTypes = propTypes

export { SocialShareSheetCTA }
